// Contenuti delle pagine istituzionali di categoria prodotto, mostrate agli
// utenti NON loggati. Architettura e testi ripresi dal documento
// "DTK_Contenuti_Web_SEO_v1" fornito dall'utente (luglio 2026): 4 categorie
// principali (Toner e cartucce laser, Gruppi completi, Ricambi, Attrezzature
// tecniche), con "Gruppi completi" che raggruppa 4 sotto-pagine (fusore,
// tamburo, sviluppo, cinghia di trasferimento).
import ricambiImg from '../assets/ricambi.jpg';
import attrezzatureImg from '../assets/attrezzature_tecniche.jpg';

export interface CategorySection {
  h2: string;
  body?: string;
  bullets?: string[];
}

export interface Subcategory {
  slug: string;
  label: string;
  description: string;
}

export interface CategoryInfo {
  slug: string;
  parentSlug?: string;
  navLabel: string;
  cardTitle: string;
  cardDescription: string;
  seoTitle: string;
  metaDescription: string;
  heading: string;
  intro: string;
  sections: CategorySection[];
  subcategories?: Subcategory[];
  cta?: { label: string; href: string };
  image: string;
}

const IMG_TONER = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/fp60urxs_1_%20TONER%20E%20CARTUCCE_FINITO.png';
const IMG_DRUM = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/0pl1r130_2.2_Gruppi%20Tamburo_finito.png';
const IMG_RICAMBI = ricambiImg;
const IMG_ATTREZZATURE = attrezzatureImg;
const IMG_FUSORE = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/ftjvb2ge_2.1%20_Gruppi%20Fusore_finiti.png';
const IMG_CINGHIA = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/7a9clm1a_2.4_Cinghie%20di%20trasferimento_finito.png';
const IMG_SVILUPPO = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/jof6pr9b_2.3_Gruppi%20Sviluppo_finito.png';
const IMG_GRUPPI_COMPLETI = 'https://customer-assets-39nsmqrw.emergentagent.net/job_e1a8c620-0cbd-4e02-a8b8-f4a98268bc01/artifacts/8yl02a37_2_GRUPPI%20COMPLETI_FINITO.png';

export const CATEGORY_INFO: CategoryInfo[] = [
  {
    slug: 'toner-cartucce-laser',
    navLabel: 'Toner e cartucce laser',
    cardTitle: 'Toner e cartucce laser',
    cardDescription: 'Consumabili originali e compatibili per apparecchiature monocromatiche e a colori, selezionati per qualità, affidabilità e convenienza.',
    seoTitle: 'Toner e cartucce laser professionali | DTK',
    metaDescription: 'Toner originali e compatibili per stampanti, fotocopiatrici e multifunzione. Soluzioni B2B per rivenditori, noleggiatori e centri assistenza.',
    heading: 'Toner e cartucce laser per il printing professionale',
    intro: 'Disponiamo di una vasta gamma di toner e cartucce laser per stampanti, fotocopiatrici e multifunzione monocromatiche e a colori. Il catalogo comprende consumabili originali e compatibili per i principali marchi, selezionati per offrire risultati di stampa uniformi, corretta compatibilità con le apparecchiature e prestazioni affidabili durante l\'intero ciclo di utilizzo.',
    sections: [
      {
        h2: 'Qualità certificata e conformità totale',
        body: 'Tutti i nostri toner rispettano i più alti standard internazionali: CE, ISO 9001, ISO 14001, REACH, RoHS, certificazioni orientate alla sicurezza, alla qualità costruttiva e alla riduzione dell\'impatto ambientale. Questi standard caratterizzano i migliori prodotti alternativi di fascia premium presenti sul mercato, la scelta del fornitore giusto fa la differenza.',
      },
      {
        h2: 'Un\'offerta completa per diverse esigenze di stampa',
        body: 'Che si tratti di garantire prestazioni elevate o di contenere il costo per pagina, DTK propone soluzioni adatte a differenti volumi di lavoro e fasce di utilizzo.',
        bullets: ['Toner originali', 'Toner compatibili', 'Cartucce laser monocromatiche', 'Cartucce laser a colori', 'Toner refill in busta', 'Developer e materiali di sviluppo'],
      },
      {
        h2: 'Supporto nella ricerca della referenza corretta',
        body: 'Il nostro team supporta il cliente nell\'identificazione del consumabile attraverso codice OEM, modello dell\'apparecchiatura e caratteristiche di utilizzo. Quando disponibile, proponiamo più alternative per consentire una scelta coerente con prestazioni richieste, budget e frequenza di stampa.',
      },
      {
        h2: 'Scopri anche KTEK',
        body: 'Per chi cerca un\'alternativa compatibile selezionata direttamente da DTK, il marchio KTEK propone due linee distinte: KTEK PRO per le alte prestazioni e KTEK SMART per una maggiore convenienza di costo.',
      },
    ],
    cta: { label: 'Scopri le linee KTEK', href: '/ktek' },
    image: IMG_TONER,
  },
  {
    slug: 'gruppi-completi',
    navLabel: 'Gruppi completi',
    cardTitle: 'Gruppi completi',
    cardDescription: 'Unità fusore, tamburo, sviluppo e trasferimento pronte per interventi di sostituzione e manutenzione.',
    seoTitle: 'Gruppi completi per stampanti e fotocopiatrici | DTK',
    metaDescription: 'Gruppi fusore, tamburo, sviluppo e cinghia di trasferimento per stampanti, fotocopiatrici e multifunzione. Soluzioni originali e compatibili.',
    heading: 'Gruppi completi per interventi rapidi e affidabili',
    intro: 'I gruppi completi rappresentano la soluzione ideale per sostituire in modo semplice e sicuro le principali unità funzionali di stampanti, fotocopiatrici e multifunzione. DTK distribuisce gruppi completi originali, compatibili e, ove previsti, rigenerati, selezionati per garantire corretta installazione, affidabilità operativa e continuità delle prestazioni.',
    subcategories: [
      { slug: 'gruppi-fusore', label: 'Gruppi fusore', description: 'Fissano il toner sul supporto attraverso calore e pressione e permettono di ripristinare la corretta qualità di stampa.' },
      { slug: 'gruppi-tamburo', label: 'Gruppi tamburo', description: 'Contribuiscono alla formazione e al trasferimento dell\'immagine, incidendo su definizione e uniformità della stampa.' },
      { slug: 'gruppi-sviluppo', label: 'Gruppi sviluppo', description: 'Gestiscono il trasferimento del toner verso il tamburo e influenzano densità e stabilità dell\'immagine.' },
      { slug: 'gruppi-cinghia-trasferimento', label: 'Gruppi cinghia di trasferimento', description: 'Consentono il passaggio corretto dell\'immagine al foglio, in particolare nelle apparecchiature laser a colori.' },
    ],
    sections: [
      { h2: 'Identificazione e compatibilità', body: 'Per individuare l\'unità corretta è possibile partire dal codice originale, dal modello dell\'apparecchiatura o dalla descrizione del componente. Il supporto DTK aiuta a ridurre errori di selezione e tempi di fermo macchina.' },
    ],
    image: IMG_GRUPPI_COMPLETI,
  },
  {
    slug: 'gruppi-fusore',
    parentSlug: 'gruppi-completi',
    navLabel: 'Gruppi fusore',
    cardTitle: 'Gruppi fusore',
    cardDescription: 'Fissano il toner sul supporto attraverso calore e pressione e permettono di ripristinare la corretta qualità di stampa.',
    seoTitle: 'Gruppi fusore per stampanti e fotocopiatrici | DTK',
    metaDescription: 'Gruppi fusore originali, compatibili e rigenerati per stampanti, fotocopiatrici e multifunzione. Supporto nella ricerca della corretta unità fusore.',
    heading: 'Gruppi fusore per stampanti, fotocopiatrici e multifunzione',
    intro: 'Il gruppo fusore (o Unità Fusore) è l\'unità che fissa il toner sul foglio attraverso una combinazione controllata di calore e pressione. Il suo corretto funzionamento è essenziale per ottenere stampe pulite, uniformi e resistenti.',
    sections: [
      { h2: 'Soluzioni per manutenzione e sostituzione', body: 'DTK propone gruppi fusore completi per numerosi modelli di stampanti e multifunzione, disponibili in versione originale, compatibile o rigenerata in base alla referenza.' },
      { h2: 'Quando sostituire il gruppo fusore', body: 'Una sostituzione può essere necessaria in presenza di toner non fissato, macchie ricorrenti, pieghe, inceppamenti, rumori anomali o difetti che si ripetono a intervalli regolari sul foglio.' },
      { h2: 'Ricerca per codice o modello', body: 'Il cliente può individuare il prodotto attraverso codice OEM, modello dell\'apparecchiatura o caratteristiche dell\'unità. Il team DTK supporta la verifica delle compatibilità e delle eventuali alternative disponibili.' },
    ],
    image: IMG_FUSORE,
  },
  {
    slug: 'gruppi-tamburo',
    parentSlug: 'gruppi-completi',
    navLabel: 'Gruppi tamburo',
    cardTitle: 'Gruppi tamburo',
    cardDescription: 'Contribuiscono alla formazione e al trasferimento dell\'immagine, incidendo su definizione e uniformità della stampa.',
    seoTitle: 'Gruppi tamburo per stampanti e multifunzione | DTK',
    metaDescription: 'Unità e gruppi tamburo originali e compatibili per stampanti, fotocopiatrici e multifunzione monocromatiche e a colori.',
    heading: 'Gruppi tamburo per una qualità di stampa uniforme',
    intro: 'Il gruppo tamburo (o Unità Tamburo) svolge un ruolo fondamentale nella formazione e nel trasferimento dell\'immagine. L\'efficienza del tamburo influenza definizione, uniformità e pulizia della stampa.',
    sections: [
      { h2: 'Unità complete per apparecchiature mono e colore', body: 'Disponiamo di gruppi tamburo per numerosi modelli di stampanti, fotocopiatrici e multifunzione, in versioni originali e compatibili accuratamente selezionate.' },
      { h2: 'Segnali di usura', body: 'Linee, punti ripetuti, sfondi grigi, immagini sbiadite o difetti ciclici possono indicare l\'usura del tamburo o di altri componenti dell\'unità.' },
      { h2: 'Supporto alla corretta identificazione', body: 'Codice originale e modello macchina consentono di verificare la referenza. DTK aiuta inoltre a distinguere tra tamburo singolo, drum kit e gruppo tamburo completo.' },
    ],
    image: IMG_DRUM,
  },
  {
    slug: 'gruppi-sviluppo',
    parentSlug: 'gruppi-completi',
    navLabel: 'Gruppi sviluppo',
    cardTitle: 'Gruppi sviluppo',
    cardDescription: 'Gestiscono il trasferimento del toner verso il tamburo e influenzano densità e stabilità dell\'immagine.',
    seoTitle: 'Gruppi sviluppo per stampanti e fotocopiatrici | DTK',
    metaDescription: 'Gruppi sviluppo e developer unit per stampanti, fotocopiatrici e multifunzione. Soluzioni per manutenzione e ripristino della densità di stampa.',
    heading: 'Gruppi sviluppo per densità e stabilità dell\'immagine',
    intro: 'Il gruppo sviluppo (o Unità Developer) trasferisce il toner verso il tamburo fotosensibile e contribuisce direttamente alla densità, all\'uniformità e alla stabilità dell\'immagine.',
    sections: [
      { h2: 'Unità complete e componenti correlati', body: 'DTK propone gruppi sviluppo completi e prodotti correlati destinati agli interventi di manutenzione, sostituzione programmata e riparazione delle apparecchiature professionali.' },
      { h2: 'Applicazioni monocromatiche e a colori', body: 'La gamma comprende unità per sistemi mono e colore. Nelle apparecchiature a colori è essenziale identificare correttamente la posizione e il colore dell\'unità.' },
      { h2: 'Ricerca tecnica assistita', body: 'Il nostro supporto aiuta a verificare codice, compatibilità, configurazione e disponibilità del prodotto corretto.' },
    ],
    image: IMG_SVILUPPO,
  },
  {
    slug: 'gruppi-cinghia-trasferimento',
    parentSlug: 'gruppi-completi',
    navLabel: 'Gruppi cinghia di trasferimento',
    cardTitle: 'Gruppi cinghia di trasferimento',
    cardDescription: 'Consentono il passaggio corretto dell\'immagine al foglio, in particolare nelle apparecchiature laser a colori.',
    seoTitle: 'Cinghie e gruppi di trasferimento per stampanti | DTK',
    metaDescription: 'Transfer belt e gruppi cinghia di trasferimento originali e compatibili per stampanti laser a colori, fotocopiatrici e multifunzione.',
    heading: 'Gruppi cinghia di trasferimento per sistemi laser a colori',
    intro: 'La cinghia di trasferimento (o Unità Cinghia di Trasferimento) consente il corretto passaggio dell\'immagine dal sistema di stampa al foglio ed è particolarmente importante nelle apparecchiature laser a colori.',
    sections: [
      { h2: 'Transfer belt e transfer unit', body: 'La gamma DTK comprende non solo transfer belt assemblate, ma anche cinghie singole per i principali modelli di stampanti e multifunzione.' },
      { h2: 'Difetti associati al trasferimento', body: 'Bande, immagini sdoppiate, difetti cromatici, irregolarità o residui sulla pagina possono essere collegati all\'usura o alla contaminazione dell\'unità.' },
      { h2: 'Compatibilità verificata', body: 'La corretta identificazione richiede il controllo del modello e del codice OEM. DTK supporta il cliente nella ricerca dell\'unità appropriata.' },
    ],
    image: IMG_CINGHIA,
  },
  {
    slug: 'ricambi-stampanti-fotocopiatrici',
    navLabel: 'Ricambi',
    cardTitle: 'Ricambi',
    cardDescription: 'Componenti originali e compatibili per riparazione, manutenzione e rigenerazione delle apparecchiature.',
    seoTitle: 'Ricambi per stampanti e fotocopiatrici | DTK',
    metaDescription: 'Ricambi originali e compatibili per stampanti, fotocopiatrici e multifunzione: tamburi OPC, lame, rulli, ingranaggi, sensori e componenti tecnici.',
    heading: 'Ricambi per stampanti, fotocopiatrici e multifunzione',
    intro: 'Anche il più piccolo componente può incidere sul corretto funzionamento di una stampante o di una multifunzione. Per questo DTK mette a disposizione una gamma ampia e specializzata di ricambi originali e compatibili destinati alla manutenzione, alla riparazione e alla rigenerazione delle apparecchiature.',
    sections: [
      {
        h2: 'Una gamma specializzata di componenti tecnici',
        bullets: [
          'Tamburi fotosensibili OPC',
          'Lame di pulizia tamburo, lame di pulizia cinghie di trasferimento e recovery blade',
          'Rulli fusori superiori',
          'Rulli pressori inferiori',
          'Pellicole fusore e fixing film assembly',
          'Rulli di carica (PCR) e rulli magnetici',
          'Rulli di pulizia, barre di cera, barre lubrificanti',
          'Rulli di presa carta e separazione',
          'Boccole, cuscinetti e ingranaggi',
          'Chip, termistori, termostati e sensori',
          'Resistenze e lampade fusore',
          'Componenti elettrici e meccanici',
          'Vaschette di recupero toner',
          'Kit di manutenzione completi',
        ],
      },
      {
        h2: 'Dal codice al ricambio corretto',
        body: 'La nostra esperienza ci permette di supportare il cliente nell\'identificazione del ricambio attraverso il codice originale, il modello dell\'apparecchiatura o le caratteristiche tecniche del componente. Quando esistono più configurazioni per uno stesso modello, verifichiamo le informazioni disponibili per ridurre il rischio di errori e proporre l\'alternativa più coerente.',
      },
    ],
    image: IMG_RICAMBI,
  },
  {
    slug: 'attrezzature-tecniche',
    navLabel: 'Attrezzature Tecniche',
    cardTitle: 'Attrezzature Tecniche',
    cardDescription: 'Strumenti, aspiratori, prodotti per la pulizia e accessori dedicati ai tecnici del settore printing.',
    seoTitle: 'Attrezzature per tecnici di stampanti e fotocopiatrici | DTK',
    metaDescription: 'Aspiratori toner, strumenti, prodotti di pulizia, lubrificanti e accessori per manutenzione e assistenza tecnica di stampanti e multifunzione.',
    heading: 'Attrezzature tecniche per manutenzione e assistenza',
    intro: 'DTK affianca all\'offerta di consumabili e ricambi una selezione di attrezzature, strumenti e accessori destinati ai tecnici e ai professionisti della manutenzione. Prodotti scelti per rendere gli interventi più semplici, precisi e sicuri, sia in laboratorio sia presso la sede del cliente.',
    sections: [
      {
        h2: 'Strumenti professionali per il settore printing',
        bullets: ['Aspiratori specifici per toner', 'Filtri e accessori per aspiratori', 'Spray multiuso', 'Panni e materiali antistatici per la pulizia delle apparecchiature', 'Lubrificanti e grassi tecnici'],
      },
      {
        h2: 'Pensate per chi lavora sulle apparecchiature',
        body: 'La selezione è dedicata a chi interviene ogni giorno su stampanti, fotocopiatrici e multifunzione e ha bisogno di prodotti affidabili, pratici e adatti al lavoro quotidiano.',
      },
    ],
    image: IMG_ATTREZZATURE,
  },
];

/** Categorie di primo livello, mostrate nella panoramica e nella sidebar
 * (escludendo le sotto-pagine di "Gruppi completi"). */
export const TOP_LEVEL_CATEGORIES = CATEGORY_INFO.filter(c => !c.parentSlug);
